import { useQuery } from '@tanstack/react-query';
import { useAtom, useSetAtom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';
import { queryMe } from '../me/api';
import { GenerationType } from '../video-model/model-spec';
import { generationDataFamilyAtom } from '../video/store';

const getReferenceImageAtom = (
  accountId: string,
  isLongVideoSupported?: boolean,
) => {
  return generationDataFamilyAtom({
    accountId,
    type: GenerationType.Reference,
    isLongVideoSupported,
  });
};

export function useReadReferenceImagePageData(isLongVideoSupported: boolean) {
  const { data } = useQuery(queryMe);

  const read = useAtomCallback(
    useCallback(
      (get) => {
        const curr = get(
          getReferenceImageAtom(data.name, isLongVideoSupported),
        );
        return curr;
      },
      [isLongVideoSupported, data.name],
    ),
  );
  return read;
}

export function useSetReferenceImagePageData(isLongVideoSupported: boolean) {
  const { data } = useQuery(queryMe);
  return useSetAtom(getReferenceImageAtom(data.name, isLongVideoSupported));
}

export function useReferenceImagePageData(isLongVideoSupported: boolean) {
  const { data } = useQuery(queryMe);
  return useAtom(getReferenceImageAtom(data.name, isLongVideoSupported));
}
